module.exports = __webpack_public_path__ + "static/media/okta-logo.b5024396.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/okta-logo.svg
// module id = 564
// module chunks = 1